export default {
  header: {
    searchPlaceholder: "Search"
  },
  notifications: {
    title: "Notifications",
    upToDate: "You're all up to date!",
    noActivity: "You have no unread activity here."
  },
  settingsMenu: {
    title: "Settings",
    connections: "Connection service",
    users: "Users",
    teams: "Teams",
    groups: "Groups",
    permissions: "Permissions",
    devops: "DevOps service",
    usage: "Usage & Quotas",
    subscription: "Subscription"
  },
  helpMenu: {
    title: "Help",
    documentation: "Documentation",
    shortcuts: "Keyboard shortcuts",
    tutorials: "Video tutorials",
    gettingStarted: "Getting started guide",
    support: "Support / Contact",
    about: "About"
  },
  userMenu: {
    title: "My profile",
    defaultName: "User",
    role: "Role:",
    organization: "Organization:",
    myAccount: "My account",
    logout: "Logout"
  },
  workspacePanel: {
    title: "Workspaces",
    searchPlaceholder: "Search a project",
    noProjects: "No saved projects.",
    newWorkspace: "New workspace"
  },
  hero: {
    title: "Welcome to GenIaC",
    subtitle: "Design, generate and deploy your cloud infrastructure in a few clicks",
    startNow: "Start now",
    exploreTemplates: "Explore templates"
  },
  stats: {
    architecturesCreated: "Architectures created",
    resourcesDeployed: "Resources deployed",
    savingsRealized: "Savings realized",
    activeUsers: "Active users"
  },
  workspaces: {
    title: "My workspaces",
    tabs: {
      recent: "Recent",
      favorites: "Favorites",
      myApps: "My applications",
      external: "From external organizations"
    },
    searchPlaceholder: "Filter by keyword",
    filters: "Filters",
    table: {
      name: "Name",
      type: "Type",
      opened: "Opened",
      location: "Location",
      approval: "Approval",
      confidentiality: "Confidentiality"
    },
    types: {
      workspace: "Workspace",
      report: "Report",
      architecture: "Architecture",
      template: "Template"
    },
    approval: {
      approved: "Approved",
      pending: "Pending"
    },
    confidentiality: {
      confidential: "Confidential",
      public: "Public"
    },
    timeAgo: {
      hours_one: "{{count}} hour ago",
      hours_other: "{{count}} hours ago",
      yesterday: "Yesterday",
      days_one: "{{count}} day ago",
      days_other: "{{count}} days ago",
      week: "1 week ago"
    },
    noWorkspaces: "No workspaces found",
    resultsCount: "{{count}} workspace displayed",
    resultsCount_plural: "{{count}} workspaces displayed"
  },
  quickActions: {
    title: "Quick actions",
    createArchitecture: {
      title: "Create architecture",
      description: "Start with a blank canvas"
    },
    exploreTemplates: {
      title: "Explore templates",
      description: "{{count}} preconfigured architectures"
    },
    viewProjects: {
      title: "View my projects",
      description: "Access your architectures"
    },
    start: "Start"
  },
  features: {
    title: "Key features",
    multiCloud: {
      title: "Multi-Cloud",
      description: "Manage Azure, AWS and GCP from a single platform"
    },
    iac: {
      title: "Infrastructure as Code",
      description: "Automatically generate Terraform and Bicep"
    },
    fastDeployment: {
      title: "Fast Deployment",
      description: "Deploy your architectures in a few clicks"
    },
    security: {
      title: "Security & Compliance",
      description: "Best practices and automatic validation"
    },
    learnMore: "Learn more"
  },
  cloudResources: {
    title: "Available Cloud resources",
    more: "+{{count}} more",
    validationMessage: "All resources are validated and follow security best practices"
  },
  cta: {
    title: "Ready to start?",
    subtitle: "Create your first cloud architecture in less than 5 minutes",
    button: "Create my first architecture"
  }
};
